/* eslint-disable camelcase */
import { OneOnOneTemplateType } from "@teaming/common-enums";
const {
	REGULAR_WEEKLY,
	SOLVE_PROBLEMS,
	RESOLVE_CONFLICTS,
	GET_FEEDBACK,
	GIVE_FEEDBACK,
	REVIEW_PERFORMANCE,
	SET_GOALS,
	PROGRESS_CHECK_IN,
	RECOGNIZE_AND_APPRECIATE,
	ROLE_ALIGNMENT,
	ENGAGEMENT_CHECK_IN,
	HYBRID_WORK_CHECK_IN,
	REMOTE_WORK_CHECK_IN,
	PROFESSIONAL_DEVELOPMENT,
	SKIP_LEVEL_MEETING,
	FIRST_ONE_ON_ONE,
	QUARTERLY_PERFORMANCE_REVIEW,
	ANNUAL_PERFORMANCE_REVIEW,
	EMPLOYEE_ONBOARDING_30_60_90,
} = OneOnOneTemplateType;

export default {
	//
	// 01 REGULAR_WEEKLY
	//
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_title` ]: "Regular Weekly",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_description` ]: "Check-in on the most important work priorities each week.",

	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic1` ]: "Check-in",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic1Bullet1` ]: "[Grab an icebreaker from the Topic Suggestions -->]",

	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic2` ]: "Review Goals/OKRs",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic2Bullet1` ]: "What did you accomplish last week?",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic2Bullet2` ]: "What do you want to accomplish this week?",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic2Bullet3` ]: "Any necessary status updates?",

	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic3` ]: "Blockers",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic3Bullet1` ]: "Any challenges?",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic3Bullet2` ]: "How can I help?",

	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic4` ]: "Questions",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic4Bullet1` ]: "Anything else we should discuss today?",

	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic5` ]: "Action items",
	[ `ONE_ON_ONE_${ REGULAR_WEEKLY }_topic5ActionItem1` ]: "What actions do we need to do out of this meeting?",

	//
	// 02 SOLVE_PROBLEMS
	//
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_title` ]: "Solve Problem(s)",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_description` ]: "Help someone solve any kind of work-related problem. [Based on the popular coaching model, GROW. Goal, Reality, Options, Will].",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_subTitle` ]: "Using the GROW model",

	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic1` ]: "What’s your Goal?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic1Bullet1` ]: "To solve what problem? Or, what is the goal of our conversation?",

	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic2` ]: "What’s the current Reality?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic2Bullet1` ]: "How did this problem happen?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic2Bullet2` ]: "Why did this problem happen?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic2Bullet3` ]: "Is there any missing information about the problem?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic2Bullet4` ]: "Can anyone else provide more context about the problem?",

	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic3` ]: "What are the Options to solve this problem?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic3Bullet1` ]: "If you could wave a magic wand to solve this problem, how would it be solved?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic3Bullet2` ]: "What are other ways this problem can be solved?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic3Bullet3` ]: "What are the strengths, weaknesses, and risks of these options?",

	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic4` ]: "What Will you do now?",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic4Bullet1` ]: "Define an action plan to solve the problem (and communicate with the necessary people.)",
	[ `ONE_ON_ONE_${ SOLVE_PROBLEMS }_topic4ActionItem1` ]: "What action items do we have out of this meeting?",

	//
	// 03 RESOLVE_CONFLICTS
	//
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_title` ]: "Resolve Conflict(s)",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_description` ]: "Help team members resolve conflicts at work. [Based on the popular coaching model, GROW. Goal, Reality, Options, Will].",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_subTitle` ]: "Using the GROW model",

	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic1` ]: "What’s your Goal?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic1Bullet1` ]: "What is the conflict to resolve? Or, what is the goal of our conversation?",

	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic2` ]: "What’s the current Reality?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic2Bullet1` ]: "How did this conflict happen?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic2Bullet2` ]: "Why did this conflict happen?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic2Bullet3` ]: "Is there any missing information about the conflict?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic2Bullet4` ]: "Can anyone else provide more context about the conflict?",

	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic3` ]: "What are the Options to solve this conflict?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic3Bullet1` ]: "If you could wave a magic wand to resolve this conflict, how would it be resolved?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic3Bullet2` ]: "What are other ways this conflict can be resolved?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic3Bullet3` ]: "What are the strengths, weaknesses, and risks of these options?",

	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic4` ]: "What Will you do now?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic4Bullet1` ]: "What will you do to resolve this conflict?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic4Bullet2` ]: "How will you communicate with the person(s) involved?",
	[ `ONE_ON_ONE_${ RESOLVE_CONFLICTS }_topic4ActionItem1` ]: "What action items do we have out of this meeting?",

	//
	// 04 GET_FEEDBACK
	//
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_title` ]: "Get Feedback",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_description` ]: "Solicit feedback that you need on work or how to handle different situation(s) at work.",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_subTitle` ]: "Use this template to get the type of feedback you need. It's good practice to review \"About\" and \"Work Styes\" before asking for feedback.",

	[ `ONE_ON_ONE_${ GET_FEEDBACK }_heading1` ]: "I'd like:",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_bullet1` ]: "Feedback on [my work]",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_paragraph1` ]: "Or,",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_bullet2` ]: "Feedback on [my behavior; how I reacted to something, handled something with a team member, etc.]",

	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic1` ]: "Will You Coach me?",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic1Paragraph1` ]: "Ask me questions, offer different options, and lead me to discover how I can improve.",

	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic2` ]: "Will You Teach me?",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic2Paragraph1` ]: "Teach me how to do this because I don't know or I am unsure.",

	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic3` ]: "Will You Collaborate with me?",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic3Paragraph1` ]: "Let's actually work on X together so I can watch you and see how you do something.",

	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic4` ]: "Will You Delegate to me?",
	[ `ONE_ON_ONE_${ GET_FEEDBACK }_topic4Paragraph1` ]: "Will you make this easier for me by telling me how you want something done?",

	//
	// 05 GIVE_FEEDBACK
	//
	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_title` ]: "Give Feedback",
	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_description` ]: "Give necessary feedback in a way that someone can absorb your feedback and put it into action.",
	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_subTitle` ]: "Use this template to give feedback in a way that's easy for someone to hear and make actionable. It's good practice to review \"About\" and \"Work Styes\" before giving feedback.",

	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic1` ]: "Can we talk about [X]?",

	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic2` ]: "What about [X] is going well? Not going well?",

	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic3` ]: "Something I really appreciate about you is...",

	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic4` ]: "I think you did a great job when you…[share specifics]. It showed that you had [valued trait]….",

	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic5` ]: "I would love to see you do more of [A] as it relates to [B]",

	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic6` ]: "I can see you’re having a positive impact in...",
	[ `ONE_ON_ONE_${ GIVE_FEEDBACK }_topic6ActionItem1` ]: "What action items do we have out of this meeting?",

	//
	// 06 REVIEW_PERFORMANCE
	//
	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_title` ]: "Review Performance",
	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_description` ]: "Have healthy, productive performance conversations to keep everyone on track to achieve goals.",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic1` ]: "Check-in",
	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic1Bullet1` ]: "How are you?",
	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic1Bullet2` ]: "How are you feeling coming into this meeting?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic2` ]: "What were the highlights of your past month/quarter/year?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic3` ]: "What could have gone better last month/quarter/year?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic4` ]: "What accomplishment are you most proud of from this month/quarter/year?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic5` ]: "What kind of support helped you achieve your goals?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic6` ]: "What support did you need to achieve the goals that you didn't receive?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic7` ]: "What obstacles did you face in achieving your goals?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic8` ]: "What work distracted you from your goals?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic9` ]: "How did you maintain focus on your goals?",

	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic10` ]: "Do you know how your goals impact team goals?",
	[ `ONE_ON_ONE_${ REVIEW_PERFORMANCE }_topic10ActionItem1` ]: "Action Item: Add new Goals and Key Measures in the Goals tab",

	//
	// 07 SET_GOALS
	//
	[ `ONE_ON_ONE_${ SET_GOALS }_title` ]: "Set Goals",
	[ `ONE_ON_ONE_${ SET_GOALS }_description` ]: "Set goals with clarity about how they are measured and who is accountable.",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic1` ]: "What are your goals for the next quarter/year?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic2` ]: "What steps will you take to attain these goals?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic3` ]: "What kind of support do you need to achieve your goals?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic4` ]: "What obstacles are in the way of you achieving your goals?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic5` ]: "What can you start/stop/keep doing to reach your goals?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic6` ]: "Do you know how your goals impact the company’s goals?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic7` ]: "What questions do you have about the company’s mission or values?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic8` ]: "Are these goals challenging but attainable?",

	[ `ONE_ON_ONE_${ SET_GOALS }_topic9` ]: "How will you measure or track your progress on these goals?",
	[ `ONE_ON_ONE_${ SET_GOALS }_topic9ActionItem1` ]: "Action Item: Add Goals and Key Measures in the Goals tab",

	//
	// 08 PROGRESS_CHECK_IN
	//
	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_title` ]: "Progress Check-in",
	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_description` ]: "Use to communicate about the current status of work and progress.",

	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic1` ]: "How are your projects or tasks going?",

	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic2` ]: "How are you prioritizing your projects or tasks?",

	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic3` ]: "What are the roadblocks or bottlenecks?",

	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic4` ]: "What could keep you from completing the projects or tasks on time?",

	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic5` ]: "Is there anything that would help you to complete your projects or tasks?",

	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic6` ]: "Is there anything I can do to help you stay accountable and on track?",
	[ `ONE_ON_ONE_${ PROGRESS_CHECK_IN }_topic6ActionItem1` ]: "Action Item: Breakdown project into Goals and Key Measures in the Goals Tab or make a to-do list in the Action Items tab",

	//
	// 09 RECOGNIZE_AND_APPRECIATE
	//
	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_title` ]: "Recognize and Appreciate",
	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_description` ]: "Understand how team members prefer to be recognized and what makes them feel valued at work.",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic1` ]: "What makes you feel appreciated at work? Underappreciated?",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic2` ]: "How do you like to be recognized?",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic3` ]: "Which recognition or rewards are most meaningful to you?",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic4` ]: "What work have you not received recognition for?",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic5` ]: "Overall, do you feel recognized for your contributions? Why or why not?",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic6` ]: "Have you received recognition from your peers lately? If so, what for?",

	[ `ONE_ON_ONE_${ RECOGNIZE_AND_APPRECIATE }_topic7` ]: "How do you make your teammates feel appreciated?",

	//
	// 10 ROLE_ALIGNMENT
	//
	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_title` ]: "Role Alignment",
	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_description` ]: "Uncover a team member’s perceived strengths, weaknesses, and preferences. Explore where their role aligns and where there may be opportunities for growth.",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic1` ]: "What do you wish you could do less often?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic2` ]: "What do you wish you could do more often?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic3` ]: "What makes you proud of the work you do?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic4` ]: "Which of your strengths are under-utilized in your current role?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic5` ]: "When was the last time you felt “flow” or “in the zone” losing yourself in your work?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic6` ]: "What ideas do you have about how we can match more of your talents to responsibilities?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic7` ]: "How does this job align with your future career goals?",

	[ `ONE_ON_ONE_${ ROLE_ALIGNMENT }_topic8` ]: "What other areas of the team or the company could benefit from your strengths? How?",

	//
	// 11 ENGAGEMENT_CHECK_IN
	//
	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_title` ]: "Engagement Check-In",
	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_description` ]: "Understand how engaged your team members are in their work and uncover ways to improve it.",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic1` ]: "What attracted you to this position/role?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic2` ]: "What attracted you to this organization?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic3` ]: "What makes you happy with your job?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic4` ]: "What makes you happy with this company?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic5` ]: "What makes or would make you want to stay in this job and company over the next two years?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic6` ]: "What things about this company, presently or in the future, would lead you to see yourself somewhere else?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic7` ]: "When you see people leave our company, why do you think they leave?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic8` ]: "Do you feel valued in your current role? Why or why not?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic9` ]: "Do you get fulfillment from your job? Why or why not?",

	[ `ONE_ON_ONE_${ ENGAGEMENT_CHECK_IN }_topic10` ]: "What support can I provide to help you feel more engaged with work?",

	//
	// 12 HYBRID_WORK_CHECK_IN
	//
	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_title` ]: "Hybrid Work Check-In",
	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_description` ]: "Talk about what’s working, what’s not, and how to improve a hybrid work environment with a team member.",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic1` ]: "How is hybrid going for you? What do you like? Dislikes?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic2` ]: "What’s important to you about your hybrid schedule?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic3` ]: "How is collaborating with team members? What’s working? What’s not?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic4` ]: "How is communication? Do you feel you know what you need to know when you need to know it?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic5` ]: "In your view, what aspects of work need to happen in-person? Remotely?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic6` ]: "How can I better support you in making hybrid work for you?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic7` ]: "Should we change anything about our setup and schedule? If so, what?",

	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic8` ]: "When should we check in again about what’s working and what’s not?",
	[ `ONE_ON_ONE_${ HYBRID_WORK_CHECK_IN }_topic8ActionItem1` ]: "Action Item: Put hybrid work check-in on our 1-on-1 agenda for next quarter",

	//
	// 13 REMOTE_WORK_CHECK_IN
	//
	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_title` ]: "Remote Work Check-In",
	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_description` ]: "Share what’s working, what’s not, and how to improve a remote work environment with a team member.",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic1` ]: "How is remote going for you? What do you like? Dislikes?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic2` ]: "What’s important to you about your remote schedule?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic3` ]: "How is collaborating with team members? What’s working? What’s not?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic4` ]: "How is communication? Do you feel you know what you need to know when you need to know it?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic5` ]: "In your view, what aspects of work need to happen in-person? Remotely?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic6` ]: "Should we change anything about our setup and schedule? If so, what?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic7` ]: "How can I better support you in making remote work for you?",

	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic8` ]: "When should we check-in again about what’s working and what’s not?",
	[ `ONE_ON_ONE_${ REMOTE_WORK_CHECK_IN }_topic8ActionItem1` ]: "Action Item: Put remote work check-in on our 1-on-1 agenda for next quarter",

	//
	// 14 PROFESSIONAL_DEVELOPMENT
	//
	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_title` ]: "Professional Development",
	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_description` ]: "Uncover how team members learn best and to come up with an action plan for what’s next in their career.",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic1` ]: "What new skills would you like to develop?",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic2` ]: "How do you learn best?",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic3` ]: "What obstacles are standing in the way of your development?",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic4` ]: "What are you currently doing to improve your skills and expertise?",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic5` ]: "What can you start/stop/keep doing to help you reach your development goals?",
	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic5Bullet1` ]: "Start",
	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic5Bullet2` ]: "Stop",
	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic5Bullet3` ]: "Keep doing",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic6` ]: "How will you use what you learn moving forward in your job?",

	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic7` ]: "Is there anything I can do to help you stay accountable and on track?",
	[ `ONE_ON_ONE_${ PROFESSIONAL_DEVELOPMENT }_topic7ActionItem1` ]: "Action Item: Add professional development Goals and Key Measures in the Goals Tab",

	//
	// 15 SKIP_LEVEL_MEETING
	//
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_title` ]: "Skip Level Meeting",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_description` ]: "Designed for conversations between a team member and their manager’s manager.",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic1` ]: "Check-in",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic1Bullet1` ]: "What’s your favorite meal?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic1Bullet2` ]: "What was your favorite subject to study in school?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic1Bullet3` ]: "What was the first live concert you attended?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic2` ]: "What’s one thing we should start, stop, and continue doing as a team?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic2Bullet1` ]: "Start",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic2Bullet2` ]: "Stop",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic2Bullet3` ]: "Continue",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic3` ]: "What do you find unclear?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic3Bullet1` ]: "About our vision and strategy?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic3Bullet2` ]: "The impact of your work?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic4` ]: "Are you happy in your role?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic4Bullet1` ]: "What would make it better for you?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic5` ]: "What are the best parts of working with your manager?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic6` ]: "What do you wish they would change?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic6Bullet1` ]: "Do more of?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic6Bullet2` ]: "Do less of?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic7` ]: "Since you started working here, how would you characterize your career progress?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic7Bullet1` ]: "What do you wish you could do more of?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic7Bullet2` ]: "Less of?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic8` ]: "Anything burning on your mind?",

	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic9` ]: "Anything I should have asked you, but haven’t?",
	[ `ONE_ON_ONE_${ SKIP_LEVEL_MEETING }_topic9ActionItem1` ]: "Action Item: What action items do we have out of this meeting?",

	//
	// 16 FIRST_ONE_ON_ONE
	//
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_title` ]: "First 1-on-1",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_description` ]: "Everything you need to know in your first one-on-one meeting with a new hire.",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_subTitle` ]: "We’re excited to have you on the team!",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic1` ]: "Onboarding",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic1Bullet1` ]: "How is your first week going so far?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic1Bullet2` ]: "Are you missing anything? Paperwork? Access?",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2` ]: "What makes 1:1’s most valuable for you?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2Bullet1` ]: "Career Development?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2Bullet2` ]: "Skills Development?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2Bullet3` ]: "Feedback?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2Bullet4` ]: "Coaching?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2Bullet5` ]: "Information Sharing?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic2Bullet6` ]: "Action Item: Schedule recurring 1:1",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic3` ]: "About me",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic3Bullet1` ]: "Review my Workstyle",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic3Bullet2` ]: "Review my past experience",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic3Bullet3` ]: "Share my career goals",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic3Bullet4` ]: "Share my hobbies",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic3Bullet5` ]: "Share my feedback & communication preferences",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4` ]: "About you",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4Bullet1` ]: "What are your hobbies?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4Bullet2` ]: "What career goals are top of mind?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4Bullet3` ]: "How do you like to receive feedback?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4Bullet4` ]: "What’s your preferred method of communication?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4Bullet5` ]: "How do you prefer to receive recognition?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic4Bullet6` ]: "Action Item: Complete Workstyle",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic5` ]: "Work",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic5Bullet1` ]: "What are you most excited to get working on?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic5Bullet2` ]: "What does success look like after 30 days?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic5ActionItem1` ]: "Action Item: Set a Goal and Key Result(s)",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic6` ]: "The Team",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic6Bullet1` ]: "Team overview",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic6Bullet2` ]: "Meeting cadence",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic6Bullet3` ]: "Regular rituals",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic6Bullet4` ]: "Tools",

	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic7` ]: "Questions",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic7Bullet1` ]: "Any questions about the team or anything else on your mind?",
	[ `ONE_ON_ONE_${ FIRST_ONE_ON_ONE }_topic7ActionItem1` ]: "Action Item: What action items do we have out of this meeting?",

	//
	// 17 QUARTERLY_PERFORMANCE_REVIEW
	//
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_title` ]: "Quarterly Performance Review",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_description` ]: "Make every Quarterly Performance Review a healthy and productive conversation.",

	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic1` ]: "Check-in",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic1Bullet1` ]: "How are you feeling coming into this meeting?",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic1Bullet2` ]: "How do you feel about the past quarter?",

	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic2` ]: "Reflection",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic2Bullet1` ]: "What did you do well last quarter?",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic2Bullet2` ]: "What do you wish you could have done better?",

	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic3` ]: "Work Goals",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic3Bullet1` ]: "What are the upcoming company/team priorities?",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic3Bullet2` ]: "What new goal(s) should you have to make an impact?",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic3Bullet3` ]: "What new things should you start doing to achieve the goal(s)?",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic3Bullet4` ]: "What things should you stop doing to maintain focus on the goal(s)?",

	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic4` ]: "Personal Goals",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic4Bullet1` ]: "What is your career next step(s)?",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic4Bullet2` ]: "What are your personal goals (if you’d like to share them)?",

	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic5` ]: "Support",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic5Bullet1` ]: "What can I do better in the upcoming year to be a better manager for you?",

	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic6` ]: "Action Items",
	[ `ONE_ON_ONE_${ QUARTERLY_PERFORMANCE_REVIEW }_topic6ActionItem1` ]: "Action Item: What were the takeaways from this meeting? What are the next steps?",

	//
	// 18 ANNUAL_PERFORMANCE_REVIEW
	//
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_title` ]: "Annual Performance Review",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_description` ]: "Make every Annual Performance Review a healthy and productive conversation.",

	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic1` ]: "Check-in",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic1Bullet1` ]: "How are you feeling coming into this meeting?",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic1Bullet2` ]: "How do you feel about last year?",

	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic2` ]: "Reflection",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic2Bullet1` ]: "What did you do well this year?",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic2Bullet2` ]: "What do you wish you could have done better?",

	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic3` ]: "Work Goals",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic3Bullet1` ]: "What are the upcoming company/team priorities?",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic3Bullet2` ]: "What new goal(s) should you have to make an impact?",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic3Bullet3` ]: "What new things should you start doing to achieve the goal(s)?",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic3Bullet4` ]: "What things should you stop doing to maintain focus on the goal(s)?",

	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic4` ]: "Personal Goals",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic4Bullet1` ]: "What is your career next step(s)?",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic4Bullet2` ]: "What are your personal goals (if you’d like to share them)?",

	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic5` ]: "Support",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic5Bullet1` ]: "What can I do better in the upcoming year to be a better manager for you?",

	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic6` ]: "Action Items",
	[ `ONE_ON_ONE_${ ANNUAL_PERFORMANCE_REVIEW }_topic6ActionItem1` ]: "Action Item: What were the takeaways from this meeting? What are the next steps?",

	//
	// 19 EMPLOYEE_ONBOARDING_30_60_90
	//
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_title` ]: "Employee Onboarding 30/60/90",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_description` ]: "Create a success plan for the first 30, 60, and 90 days of a team member’s time in a new role. Use with a new hire, someone who was promoted, or anyone whose role changed.",

	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic1` ]: "Check-in",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic1Bullet1` ]: "[Grab an ice-breaker from the Topic Suggestions -->]",

	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic2` ]: "In 30 days, what do we want to accomplish?",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic2ActionItem1` ]: "Payroll / Health Paperwork",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic2ActionItem2` ]: "Meet 1:1 with each team member",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic2ActionItem3` ]: "Get added to necessary meetings",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic2ActionItem4` ]: "Take Workstyle assessment",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic2ActionItem5` ]: "Create Goals in Goal Tab ^",

	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic3` ]: "In 60 days, what do we want to accomplish?",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic3ActionItem1` ]: "(Action Item)",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic3ActionItem2` ]: "(Action Item)",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic3ActionItem3` ]: "(Action Item)",

	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic4` ]: "In 90 days, what do we want to accomplish?",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic4ActionItem1` ]: "(Action Item)",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic4ActionItem2` ]: "(Action Item)",
	[ `ONE_ON_ONE_${ EMPLOYEE_ONBOARDING_30_60_90 }_topic4ActionItem3` ]: "(Action Item)",
};
/* eslint-enable camelcase */
